/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePackageSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FilePackageSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.544 7.212v4.636h.832v6.779h3.744v-1.25H8.626V11.85h8.749v5.527h-2.506v1.25h3.756v-6.779h.832V7.212H6.544ZM18.113 10.6v-.002h.094V8.462H7.794v2.136h.21v.002h10.109Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m15.405 15.484-2.412-2.364-2.397 2.365.878.89.896-.884v3.135h1.25v-3.141l.91.892.875-.893Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M6.54 7.21h12.913v.5H6.54v-.5Zm4.576 10.664v-.5H8.622v.5h2.494Zm6.254-.5h-2.505v.5h2.506v-.5Zm.739-6.778v.001H8v-.001h-.21v.5H8v.001h10.11v-.001h.094v-.5h-.094ZM15.4 15.482l-.25.254-2.16-2.119-2.148 2.12-.25-.254 2.397-2.366 2.412 2.364Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FilePackageSmall
};
